import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ComunicationService {

  private updateData = new Subject<{date_from: string, date_to: string}>();
  updateData$ = this.updateData.asObservable();

  
  constructor() { }
  
  public updateDataEmit(dates: {date_from: Date, date_to: Date}) {
    let date_from = '';
    let date_to = '';
    if(dates.date_from)
      date_from = this.formatDatesToString(dates.date_from)
    if(dates.date_to)    
      date_to = this.formatDatesToString(dates.date_to as Date)
    this.updateData.next({date_from: date_from, date_to: date_to});
  }

  private formatDatesToString(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  }

}
